import LearnerDataApiFunctions from 'alp-shared-components/dist/api/LearnerData';

import setupAxios from './setup-axios';
import { fetchCookies } from '../utils';

export default function API() {
  const axiosConfig = {
    baseURL: process.env.LEARNER_DATA_API_URL
  };

  const axios = setupAxios(axiosConfig);

  axios.interceptors.request.use(
    (config) => {
      const token = fetchCookies('bigdef_token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  return LearnerDataApiFunctions(axios);
}
